import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { verifyMagicLink } from '../lib/api';

export function AuthVerifyPage() {
  const [params] = useSearchParams();
  const { onTokensReceived } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;

    const token = params.get('token');
    if (!token) {
      setError('No sign-in token found in this link.');
      return;
    }

    verifyMagicLink(token)
      .then(({ accessToken, refreshToken }) => onTokensReceived(accessToken, refreshToken))
      .then(() => navigate('/'))
      .catch(() =>
        setError('This sign-in link has expired or already been used. Please request a new one.'),
      );
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const center: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100dvh',
    padding: 'var(--space-6)',
    background: 'var(--color-bg)',
  };

  if (error) {
    return (
      <div style={center}>
        <div style={{ textAlign: 'center', maxWidth: '400px' }}>
          <h1 style={{ fontSize: '2rem', fontWeight: 800, color: 'var(--color-accent)', letterSpacing: '-0.03em' }}>
            Anchor
          </h1>
          <p style={{ color: 'var(--color-danger)', margin: 'var(--space-4) 0', fontSize: '0.9375rem' }}>
            {error}
          </p>
          <a href="/sign-in" style={{ color: 'var(--color-accent)', fontSize: '0.875rem' }}>
            Back to sign in
          </a>
        </div>
      </div>
    );
  }

  return (
    <div style={center}>
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ fontSize: '2rem', fontWeight: 800, color: 'var(--color-accent)', letterSpacing: '-0.03em' }}>
          Anchor
        </h1>
        <p style={{ color: 'var(--color-text-muted)', marginTop: 'var(--space-3)' }}>
          Signing you in…
        </p>
      </div>
    </div>
  );
}
